import React from 'react';

interface AllResourcesIconProps extends React.SVGProps<SVGSVGElement> {
  size?: number;
}

export const AllResourcesIcon: React.FC<AllResourcesIconProps> = ({ size = 20, ...props }) => {
  return (
    <svg
      fill="none"
      viewBox="0 0 20 20"
      xmlns="http://www.w3.org/2000/svg"
      {...props}
      height={size}
      width={size}
    >
      <g clipRule="evenodd" fill="#EAEFF5" fillRule="evenodd">
        <path d="M3.427 3.31a.117.117 0 0 0-.118.117v3.756a.117.117 0 0 0 .118.117h3.755a.117.117 0 0 0 .118-.117V3.427a.117.117 0 0 0-.118-.117H3.427ZM2.182 2.182a1.76 1.76 0 0 1 1.245-.515h3.755a1.76 1.76 0 0 1 1.761 1.76v3.756a1.76 1.76 0 0 1-1.76 1.76H3.426a1.76 1.76 0 0 1-1.761-1.76V3.427c0-.467.185-.915.516-1.245ZM12.816 3.31a.117.117 0 0 0-.117.117v3.756a.117.117 0 0 0 .117.117h3.756a.117.117 0 0 0 .117-.117V3.427a.117.117 0 0 0-.117-.117h-3.756Zm-1.245-1.128a1.76 1.76 0 0 1 1.245-.515h3.756a1.76 1.76 0 0 1 1.76 1.76v3.756a1.76 1.76 0 0 1-1.76 1.76h-3.756a1.76 1.76 0 0 1-1.76-1.76V3.427c0-.467.185-.915.515-1.245ZM3.427 12.7a.117.117 0 0 0-.118.117v3.756a.117.117 0 0 0 .118.117h3.755a.117.117 0 0 0 .118-.117v-3.756a.117.117 0 0 0-.118-.117H3.427Zm-1.245-1.128a1.76 1.76 0 0 1 1.245-.516h3.755a1.76 1.76 0 0 1 1.761 1.76v3.757a1.76 1.76 0 0 1-1.76 1.76H3.426a1.76 1.76 0 0 1-1.761-1.76v-3.756c0-.467.185-.915.516-1.245ZM12.816 12.7a.117.117 0 0 0-.117.117v3.756a.117.117 0 0 0 .117.117h3.756a.117.117 0 0 0 .117-.117v-3.756a.117.117 0 0 0-.117-.117h-3.756Zm-1.245-1.128a1.76 1.76 0 0 1 1.245-.516h3.756a1.76 1.76 0 0 1 1.76 1.76v3.757a1.76 1.76 0 0 1-1.76 1.76h-3.756a1.76 1.76 0 0 1-1.76-1.76v-3.756c0-.467.185-.915.515-1.245Z" />
      </g>
    </svg>
  );
};
